import { axiosEduServer } from "../utils/configAxios";

export const crearInscripcion = (data) => {
  return axiosEduServer.post('/inscripcion', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarInscripcion = (id, data) => {
  return axiosEduServer.put(`/inscripcion/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarInscripcion = (id) => {
  return axiosEduServer.delete(`/inscripcion/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneInscripcion = (id) => {
  return axiosEduServer.get(`/inscripcion/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllInscripciones = () => {
  return axiosEduServer.get('/inscripcion').then(({ data }) => data).catch((err) => { throw err });
};